export const Permission = {
    PROJECT_READ: 'project:read',
    PROJECT_CREATE: 'project:create',
    PROJECT_UPDATE: 'project:update',
    PROJECT_SUBMIT: 'project:submit',
    PROJECT_APPROVE: 'project:approve',
    PROJECT_COMPLETE: 'project:complete',
    PROJECT_DELETE: 'project:delete',
    PROJECT_ASSIGN: 'project:assign',
    DOCUMENT_READ: 'document:read',
    DOCUMENT_UPLOAD: 'document:upload',
    DOCUMENT_UPDATE: 'document:update',
    DOCUMENT_DELETE: 'document:delete',
    CUSTOMER_READ: 'customer:read',
    CUSTOMER_CREATE: 'customer:create',
    CUSTOMER_UPDATE: 'customer:update',
    CUSTOMER_DELETE: 'customer:delete',
    CONTACT_READ: 'contact:read',
    CONTACT_CREATE: 'contact:create',
    CONTACT_UPDATE: 'contact:update',
    CONTACT_DELETE: 'contact:delete',
    AI_USE: 'ai:use',
    USER_MANAGE: 'user:manage',
    AUDIT_VIEW_ALL: 'audit:view:all',
    // Iteration 3 — Prüfsachverständigen-Stammdaten und Behördenvorgänge.
    PRUEFER_READ: 'pruefer:read',
    PRUEFER_WRITE: 'pruefer:write',
    BEHOERDE_READ: 'behoerde:read',
    BEHOERDE_WRITE: 'behoerde:write',
    // Iteration 3 / Paket B — Mail-Inbound. Jeder ersteller darf sein eigenes
    // Mail-Konto pflegen und seine Inbox sehen; cross-user visibility ist
    // im Route-Layer durch userId-Filter geschützt.
    MAIL_ACCOUNT_WRITE: 'mail:account:write',
    MAIL_INBOX_READ: 'mail:inbox:read',
    // Iteration 4 — Time-Tracking + Feature-Flag-Admin
    TIME_LOG_WRITE: 'time:log:write',
    TIME_LOG_VIEW_ALL: 'time:log:view:all',
    FEATURE_FLAG_ADMIN: 'feature:flag:admin',
    // Fehler und Wuensche aus der Anwendung heraus melden. Bewusst NICHT beim
    // Gast: die Meldung landet als Vorgang im Entwicklungs-Repository, und wer
    // nur lesend zuschaut, soll dort nichts einstellen koennen.
    FEEDBACK_SUBMIT: 'feedback:submit',
    // Rueckmeldungen aller Nutzer einsehen und erneut uebermitteln.
    FEEDBACK_MANAGE: 'feedback:manage',
    // Objektbetreuung — betreute Liegenschaften. Bewusst eigene Rechte statt
    // CUSTOMER_*: Wer Stammdaten des Kunden pflegen darf, muss nicht zwingend
    // dessen Objekte anlegen duerfen, und die geplante Technikerrolle braucht
    // spaeter Lesezugriff auf Objekte ohne Zugriff auf Kundenstammdaten.
    LIEGENSCHAFT_READ: 'liegenschaft:read',
    LIEGENSCHAFT_WRITE: 'liegenschaft:write',
    LIEGENSCHAFT_DELETE: 'liegenschaft:delete',
    // Anlagenbestand und Pruefungen. `ANLAGE_PRUEFEN` ist bewusst von
    // `ANLAGE_WRITE` getrennt: Die geplante Technikerrolle soll Pruefungen
    // eintragen duerfen, ohne den Bestand umbauen zu koennen.
    ANLAGE_READ: 'anlage:read',
    ANLAGE_WRITE: 'anlage:write',
    ANLAGE_DELETE: 'anlage:delete',
    ANLAGE_PRUEFEN: 'anlage:pruefen',
    // Maengel und Begehungen. `MANGEL_ABSCHLIESSEN` ist von `MANGEL_WRITE`
    // getrennt: Einen Mangel erfassen darf jeder, der vor Ort ist — bestaetigen,
    // dass er behoben ist, soll eine bewusste Entscheidung bleiben.
    MANGEL_READ: 'mangel:read',
    MANGEL_WRITE: 'mangel:write',
    MANGEL_ABSCHLIESSEN: 'mangel:abschliessen',
    BEGEHUNG_READ: 'begehung:read',
    BEGEHUNG_WRITE: 'begehung:write',
    // QR-Etiketten ausgeben und widerrufen. Bewusst nicht beim Gast: Der Token
    // ist ein Zugang ohne Anmeldung, seine Ausgabe eine Vertrauensentscheidung.
    ASSET_TAG_MANAGE: 'assettag:manage',
    // Betreuung (Bestellung als Brandschutzbeauftragter) und wiederkehrende
    // Aufgaben je Liegenschaft. Lesen darf, wer Objekte lesen darf; schreiben
    // erfordert die Erstellerrolle — eine Bestellung ist eine Vertragstatsache.
    BETREUUNG_WRITE: 'betreuung:write',
    AUFGABE_READ: 'aufgabe:read',
    AUFGABE_WRITE: 'aufgabe:write',
    // Textbibliothek der Mängel pflegen (anlegen, ändern, deaktivieren). Lesen
    // reicht MANGEL_READ — wer Mängel sieht, darf auch die Vorlagen sehen, die
    // sie formuliert haben.
    MANGEL_VORLAGE_MANAGE: 'mangel:vorlage:manage',
    // Übernahme-Checkliste: Stand, Stellungnahme und Bewertung je Unterlage.
    // Lesen läuft über LIEGENSCHAFT_READ — die Liste ist Teil der Objektakte.
    UEBERNAHME_WRITE: 'uebernahme:write',
    // Begehungsbericht erzeugen, versenden und den KI-Entwurf anfordern. Der
    // Bericht geht an den Kunden hinaus und traegt QR-Codes ohne Anmeldung —
    // deshalb kein Gastrecht.
    BEGEHUNG_BERICHT: 'begehung:bericht',
    // Medien (Fotos, Videos, Dokumente aus dem Betrieb). Lesen darf jede Rolle
    // mit Objekt- bzw. Projekt-Leserecht — die Sichtbarkeit je Medium prüft die
    // Route über Liegenschaft oder Projekt. Hochladen und Löschen ist eine
    // Erstellerhandlung: Ein Foto ist Beleg, kein Kommentar.
    MEDIUM_READ: 'medium:read',
    MEDIUM_WRITE: 'medium:write',
};
const gastPerms = new Set([
    Permission.PROJECT_READ,
    Permission.DOCUMENT_READ,
    Permission.CUSTOMER_READ,
    Permission.CONTACT_READ,
    Permission.PRUEFER_READ,
    Permission.BEHOERDE_READ,
    Permission.LIEGENSCHAFT_READ,
    Permission.ANLAGE_READ,
    Permission.MANGEL_READ,
    Permission.BEGEHUNG_READ,
    Permission.AUFGABE_READ,
    Permission.MEDIUM_READ,
]);
const erstellerPerms = new Set([
    ...gastPerms,
    Permission.PROJECT_CREATE,
    Permission.PROJECT_UPDATE,
    Permission.PROJECT_SUBMIT,
    Permission.PROJECT_ASSIGN,
    Permission.DOCUMENT_UPLOAD,
    Permission.DOCUMENT_UPDATE,
    Permission.CUSTOMER_CREATE,
    Permission.CUSTOMER_UPDATE,
    Permission.CONTACT_CREATE,
    Permission.CONTACT_UPDATE,
    Permission.PRUEFER_WRITE,
    Permission.BEHOERDE_WRITE,
    Permission.MAIL_ACCOUNT_WRITE,
    Permission.MAIL_INBOX_READ,
    Permission.TIME_LOG_WRITE,
    Permission.AI_USE,
    Permission.FEEDBACK_SUBMIT,
    Permission.LIEGENSCHAFT_WRITE,
    Permission.ANLAGE_WRITE,
    Permission.ANLAGE_PRUEFEN,
    Permission.MANGEL_WRITE,
    Permission.MANGEL_ABSCHLIESSEN,
    Permission.BEGEHUNG_WRITE,
    Permission.ASSET_TAG_MANAGE,
    Permission.BETREUUNG_WRITE,
    Permission.AUFGABE_WRITE,
    Permission.MANGEL_VORLAGE_MANAGE,
    Permission.UEBERNAHME_WRITE,
    Permission.BEGEHUNG_BERICHT,
    Permission.MEDIUM_WRITE,
]);
const freigeberPerms = new Set([
    ...erstellerPerms,
    Permission.PROJECT_APPROVE,
    Permission.PROJECT_COMPLETE,
]);
const adminPerms = new Set([
    ...freigeberPerms,
    Permission.PROJECT_DELETE,
    Permission.CUSTOMER_DELETE,
    Permission.CONTACT_DELETE,
    Permission.DOCUMENT_DELETE,
    Permission.USER_MANAGE,
    Permission.AUDIT_VIEW_ALL,
    Permission.TIME_LOG_VIEW_ALL,
    Permission.FEATURE_FLAG_ADMIN,
    Permission.FEEDBACK_MANAGE,
    Permission.LIEGENSCHAFT_DELETE,
    Permission.ANLAGE_DELETE,
]);
export const RolePermissions = {
    gast: gastPerms,
    ersteller: erstellerPerms,
    freigeber: freigeberPerms,
    admin: adminPerms,
};
export function can(role, permission) {
    return RolePermissions[role].has(permission);
}
